import { StitchGroupConfig, StitchVariantConfig, LoadedStitchGroup } from './types';
import { registerSvgSource } from './svg-renderer';

import backLoopCfg from './definitions/back-loop/config.json';
import backPostDcCfg from './definitions/back-post-dc/config.json';
import chainCfg from './definitions/chain/config.json';
import dcDecreaseCfg from './definitions/dc-decrease/config.json';
import dcDecrease3Cfg from './definitions/dc-decrease-3/config.json';
import dcIncreaseCfg from './definitions/dc-increase/config.json';
import dcIncrease3Cfg from './definitions/dc-increase-3/config.json';
import dcPuffCfg from './definitions/dc-puff/config.json';
import doubleCfg from './definitions/double/config.json';
import doubleTrebleCfg from './definitions/double-treble/config.json';
import dtrClusterCfg from './definitions/dtr-cluster/config.json';
import dtrDecreaseCfg from './definitions/dtr-decrease/config.json';
import dtrDecrease3Cfg from './definitions/dtr-decrease-3/config.json';
import dtrIncreaseCfg from './definitions/dtr-increase/config.json';
import dtrIncrease3Cfg from './definitions/dtr-increase-3/config.json';
import frontLoopCfg from './definitions/front-loop/config.json';
import frontPostDcCfg from './definitions/front-post-dc/config.json';
import halfDoubleCfg from './definitions/half-double/config.json';
import hdcDecreaseCfg from './definitions/hdc-decrease/config.json';
import hdcDecrease3Cfg from './definitions/hdc-decrease-3/config.json';
import hdcIncreaseCfg from './definitions/hdc-increase/config.json';
import hdcIncrease3Cfg from './definitions/hdc-increase-3/config.json';
import hdcPuffCfg from './definitions/hdc-puff/config.json';
import magicRingCfg from './definitions/magic-ring/config.json';
import markerLargeCfg from './definitions/marker-large/config.json';
import markerSmallCfg from './definitions/marker-small/config.json';
import picotCfg from './definitions/picot/config.json';
import scDecreaseCfg from './definitions/sc-decrease/config.json';
import scDecrease3Cfg from './definitions/sc-decrease-3/config.json';
import scIncreaseCfg from './definitions/sc-increase/config.json';
import scIncrease3Cfg from './definitions/sc-increase-3/config.json';
import singleCfg from './definitions/single/config.json';
import slipCfg from './definitions/slip/config.json';
import trClusterCfg from './definitions/tr-cluster/config.json';
import trDecreaseCfg from './definitions/tr-decrease/config.json';
import trDecrease3Cfg from './definitions/tr-decrease-3/config.json';
import trIncreaseCfg from './definitions/tr-increase/config.json';
import trIncrease3Cfg from './definitions/tr-increase-3/config.json';
import trebleCfg from './definitions/treble/config.json';
import tripleTrebleCfg from './definitions/triple-treble/config.json';

import backLoopIc0 from './definitions/back-loop/icon.svg';
import backPostDcIc0 from './definitions/back-post-dc/icon.svg';
import chainIc0 from './definitions/chain/chain-vertical.svg';
import chainIc1 from './definitions/chain/chain-horizontal.svg';
import dcDecreaseIc0 from './definitions/dc-decrease/dc2tog.svg';
import dcDecreaseIc1 from './definitions/dc-decrease/dc2tog-l.svg';
import dcDecreaseIc2 from './definitions/dc-decrease/dc2tog-r.svg';
import dcDecrease3Ic0 from './definitions/dc-decrease-3/dc3tog.svg';
import dcIncreaseIc0 from './definitions/dc-increase/dc-inc.svg';
import dcIncreaseIc1 from './definitions/dc-increase/dc-inc-l.svg';
import dcIncreaseIc2 from './definitions/dc-increase/dc-inc-r.svg';
import dcIncrease3Ic0 from './definitions/dc-increase-3/dc-inc-3.svg';
import dcPuffIc0 from './definitions/dc-puff/dc-puff-3.svg';
import dcPuffIc1 from './definitions/dc-puff/dc-puff-5.svg';
import doubleIc0 from './definitions/double/double-1.svg';
import doubleIc1 from './definitions/double/double-2.svg';
import doubleTrebleIc0 from './definitions/double-treble/double-treble-1.svg';
import doubleTrebleIc1 from './definitions/double-treble/double-treble-2.svg';
import dtrClusterIc0 from './definitions/dtr-cluster/dtr-cluster-3.svg';
import dtrClusterIc1 from './definitions/dtr-cluster/dtr-cluster-5.svg';
import dtrDecreaseIc0 from './definitions/dtr-decrease/dtr2tog.svg';
import dtrDecreaseIc1 from './definitions/dtr-decrease/dtr2tog-l.svg';
import dtrDecreaseIc2 from './definitions/dtr-decrease/dtr2tog-r.svg';
import dtrDecrease3Ic0 from './definitions/dtr-decrease-3/dtr3tog.svg';
import dtrIncreaseIc0 from './definitions/dtr-increase/dtr-inc.svg';
import dtrIncreaseIc1 from './definitions/dtr-increase/dtr-inc-l.svg';
import dtrIncreaseIc2 from './definitions/dtr-increase/dtr-inc-r.svg';
import dtrIncrease3Ic0 from './definitions/dtr-increase-3/dtr-inc-3.svg';
import frontLoopIc0 from './definitions/front-loop/icon.svg';
import frontPostDcIc0 from './definitions/front-post-dc/icon.svg';
import halfDoubleIc0 from './definitions/half-double/icon.svg';
import hdcDecreaseIc0 from './definitions/hdc-decrease/hdc2tog.svg';
import hdcDecreaseIc1 from './definitions/hdc-decrease/hdc2tog-l.svg';
import hdcDecreaseIc2 from './definitions/hdc-decrease/hdc2tog-r.svg';
import hdcDecrease3Ic0 from './definitions/hdc-decrease-3/hdc3tog.svg';
import hdcIncreaseIc0 from './definitions/hdc-increase/hdc-inc.svg';
import hdcIncreaseIc1 from './definitions/hdc-increase/hdc-inc-l.svg';
import hdcIncreaseIc2 from './definitions/hdc-increase/hdc-inc-r.svg';
import hdcIncrease3Ic0 from './definitions/hdc-increase-3/hdc-inc-3.svg';
import hdcPuffIc0 from './definitions/hdc-puff/hdc-puff-3.svg';
import hdcPuffIc1 from './definitions/hdc-puff/hdc-puff-5.svg';
import magicRingIc0 from './definitions/magic-ring/icon.svg';
import magicRingIc1 from './definitions/magic-ring/magic-ring-2.svg';
import markerLargeIc0 from './definitions/marker-large/digit-0.svg';
import markerLargeIc1 from './definitions/marker-large/digit-1.svg';
import markerLargeIc2 from './definitions/marker-large/digit-2.svg';
import markerLargeIc3 from './definitions/marker-large/digit-3.svg';
import markerLargeIc4 from './definitions/marker-large/digit-4.svg';
import markerLargeIc5 from './definitions/marker-large/digit-5.svg';
import markerLargeIc6 from './definitions/marker-large/digit-6.svg';
import markerLargeIc7 from './definitions/marker-large/digit-7.svg';
import markerLargeIc8 from './definitions/marker-large/digit-8.svg';
import markerLargeIc9 from './definitions/marker-large/digit-9.svg';
import markerLargeIc10 from './definitions/marker-large/arrow-up.svg';
import markerLargeIc11 from './definitions/marker-large/arrow-down.svg';
import markerLargeIc12 from './definitions/marker-large/arrow-left.svg';
import markerLargeIc13 from './definitions/marker-large/arrow-right.svg';
import markerSmallIc0 from './definitions/marker-small/digit-0.svg';
import markerSmallIc1 from './definitions/marker-small/digit-1.svg';
import markerSmallIc2 from './definitions/marker-small/digit-2.svg';
import markerSmallIc3 from './definitions/marker-small/digit-3.svg';
import markerSmallIc4 from './definitions/marker-small/digit-4.svg';
import markerSmallIc5 from './definitions/marker-small/digit-5.svg';
import markerSmallIc6 from './definitions/marker-small/digit-6.svg';
import markerSmallIc7 from './definitions/marker-small/digit-7.svg';
import markerSmallIc8 from './definitions/marker-small/digit-8.svg';
import markerSmallIc9 from './definitions/marker-small/digit-9.svg';
import markerSmallIc10 from './definitions/marker-small/arrow-up.svg';
import markerSmallIc11 from './definitions/marker-small/arrow-down.svg';
import markerSmallIc12 from './definitions/marker-small/arrow-left.svg';
import markerSmallIc13 from './definitions/marker-small/arrow-right.svg';
import picotIc0 from './definitions/picot/icon.svg';
import scDecreaseIc0 from './definitions/sc-decrease/sc2tog.svg';
import scDecrease3Ic0 from './definitions/sc-decrease-3/sc3tog.svg';
import scIncreaseIc0 from './definitions/sc-increase/sc-inc.svg';
import scIncreaseIc1 from './definitions/sc-increase/sc-inc-l.svg';
import scIncreaseIc2 from './definitions/sc-increase/sc-inc-r.svg';
import scIncrease3Ic0 from './definitions/sc-increase-3/sc-inc-3.svg';
import singleIc0 from './definitions/single/single-x.svg';
import singleIc1 from './definitions/single/single-plus.svg';
import slipIc0 from './definitions/slip/icon.svg';
import slipIc1 from './definitions/slip/slip-2.svg';
import trClusterIc0 from './definitions/tr-cluster/tr-cluster-3.svg';
import trClusterIc1 from './definitions/tr-cluster/tr-cluster-5.svg';
import trDecreaseIc0 from './definitions/tr-decrease/tr2tog.svg';
import trDecreaseIc1 from './definitions/tr-decrease/tr2tog-l.svg';
import trDecreaseIc2 from './definitions/tr-decrease/tr2tog-r.svg';
import trDecrease3Ic0 from './definitions/tr-decrease-3/tr3tog.svg';
import trIncreaseIc0 from './definitions/tr-increase/tr-inc.svg';
import trIncreaseIc1 from './definitions/tr-increase/tr-inc-l.svg';
import trIncreaseIc2 from './definitions/tr-increase/tr-inc-r.svg';
import trIncrease3Ic0 from './definitions/tr-increase-3/tr-inc-3.svg';
import trebleIc0 from './definitions/treble/treble-1.svg';
import trebleIc1 from './definitions/treble/treble-2.svg';
import tripleTrebleIc0 from './definitions/triple-treble/triple-treble-1.svg';
import tripleTrebleIc1 from './definitions/triple-treble/triple-treble-2.svg';

const iconMap: Record<string, Record<string, string>> = {
  'back-loop': { 'back-loop': backLoopIc0 },
  'back-post-dc': { 'back-post-dc': backPostDcIc0 },
  'chain': { 'chain': chainIc0, 'chain-horizontal': chainIc1 },
  'dc-decrease': { 'dc2tog': dcDecreaseIc0, 'dc2tog-l': dcDecreaseIc1, 'dc2tog-r': dcDecreaseIc2 },
  'dc-decrease-3': { 'dc3tog': dcDecrease3Ic0 },
  'dc-increase': { 'dc-inc': dcIncreaseIc0, 'dc-inc-l': dcIncreaseIc1, 'dc-inc-r': dcIncreaseIc2 },
  'dc-increase-3': { 'dc-inc-3': dcIncrease3Ic0 },
  'dc-puff': { 'dc-puff-3': dcPuffIc0, 'dc-puff-5': dcPuffIc1 },
  'double': { 'double': doubleIc0, 'double-2': doubleIc1 },
  'double-treble': { 'double-treble': doubleTrebleIc0, 'double-treble-2': doubleTrebleIc1 },
  'dtr-cluster': { 'dtr-cluster-3': dtrClusterIc0, 'dtr-cluster-5': dtrClusterIc1 },
  'dtr-decrease': { 'dtr2tog': dtrDecreaseIc0, 'dtr2tog-l': dtrDecreaseIc1, 'dtr2tog-r': dtrDecreaseIc2 },
  'dtr-decrease-3': { 'dtr3tog': dtrDecrease3Ic0 },
  'dtr-increase': { 'dtr-inc': dtrIncreaseIc0, 'dtr-inc-l': dtrIncreaseIc1, 'dtr-inc-r': dtrIncreaseIc2 },
  'dtr-increase-3': { 'dtr-inc-3': dtrIncrease3Ic0 },
  'front-loop': { 'front-loop': frontLoopIc0 },
  'front-post-dc': { 'front-post-dc': frontPostDcIc0 },
  'half-double': { 'half-double': halfDoubleIc0 },
  'hdc-decrease': { 'hdc2tog': hdcDecreaseIc0, 'hdc2tog-l': hdcDecreaseIc1, 'hdc2tog-r': hdcDecreaseIc2 },
  'hdc-decrease-3': { 'hdc3tog': hdcDecrease3Ic0 },
  'hdc-increase': { 'hdc-inc': hdcIncreaseIc0, 'hdc-inc-l': hdcIncreaseIc1, 'hdc-inc-r': hdcIncreaseIc2 },
  'hdc-increase-3': { 'hdc-inc-3': hdcIncrease3Ic0 },
  'hdc-puff': { 'hdc-puff-3': hdcPuffIc0, 'hdc-puff-5': hdcPuffIc1 },
  'magic-ring': { 'magic-ring': magicRingIc0, 'magic-ring-2': magicRingIc1 },
  'marker-large': { 'marker-l-0': markerLargeIc0, 'marker-l-1': markerLargeIc1, 'marker-l-2': markerLargeIc2, 'marker-l-3': markerLargeIc3, 'marker-l-4': markerLargeIc4, 'marker-l-5': markerLargeIc5, 'marker-l-6': markerLargeIc6, 'marker-l-7': markerLargeIc7, 'marker-l-8': markerLargeIc8, 'marker-l-9': markerLargeIc9, 'marker-l-up': markerLargeIc10, 'marker-l-down': markerLargeIc11, 'marker-l-left': markerLargeIc12, 'marker-l-right': markerLargeIc13 },
  'marker-small': { 'marker-s-0': markerSmallIc0, 'marker-s-1': markerSmallIc1, 'marker-s-2': markerSmallIc2, 'marker-s-3': markerSmallIc3, 'marker-s-4': markerSmallIc4, 'marker-s-5': markerSmallIc5, 'marker-s-6': markerSmallIc6, 'marker-s-7': markerSmallIc7, 'marker-s-8': markerSmallIc8, 'marker-s-9': markerSmallIc9, 'marker-s-up': markerSmallIc10, 'marker-s-down': markerSmallIc11, 'marker-s-left': markerSmallIc12, 'marker-s-right': markerSmallIc13 },
  'picot': { 'picot': picotIc0 },
  'sc-decrease': { 'sc2tog': scDecreaseIc0 },
  'sc-decrease-3': { 'sc3tog': scDecrease3Ic0 },
  'sc-increase': { 'sc-inc': scIncreaseIc0, 'sc-inc-l': scIncreaseIc1, 'sc-inc-r': scIncreaseIc2 },
  'sc-increase-3': { 'sc-inc-3': scIncrease3Ic0 },
  'single': { 'single': singleIc0, 'single-plus': singleIc1 },
  'slip': { 'slip': slipIc0, 'slip-2': slipIc1 },
  'tr-cluster': { 'tr-cluster-3': trClusterIc0, 'tr-cluster-5': trClusterIc1 },
  'tr-decrease': { 'tr2tog': trDecreaseIc0, 'tr2tog-l': trDecreaseIc1, 'tr2tog-r': trDecreaseIc2 },
  'tr-decrease-3': { 'tr3tog': trDecrease3Ic0 },
  'tr-increase': { 'tr-inc': trIncreaseIc0, 'tr-inc-l': trIncreaseIc1, 'tr-inc-r': trIncreaseIc2 },
  'tr-increase-3': { 'tr-inc-3': trIncrease3Ic0 },
  'treble': { 'treble': trebleIc0, 'treble-2': trebleIc1 },
  'triple-treble': { 'triple-treble': tripleTrebleIc0, 'triple-treble-2': tripleTrebleIc1 },
};

const allConfigs: StitchGroupConfig[] = [
  backLoopCfg, backPostDcCfg, chainCfg, dcDecreaseCfg, dcDecrease3Cfg,
  dcIncreaseCfg, dcIncrease3Cfg, dcPuffCfg, doubleCfg, doubleTrebleCfg,
  dtrClusterCfg, dtrDecreaseCfg, dtrDecrease3Cfg, dtrIncreaseCfg, dtrIncrease3Cfg,
  frontLoopCfg, frontPostDcCfg, halfDoubleCfg, hdcDecreaseCfg, hdcDecrease3Cfg,
  hdcIncreaseCfg, hdcIncrease3Cfg, hdcPuffCfg, magicRingCfg, markerLargeCfg,
  markerSmallCfg, picotCfg, scDecreaseCfg, scDecrease3Cfg, scIncreaseCfg,
  scIncrease3Cfg, singleCfg, slipCfg, trClusterCfg, trDecreaseCfg,
  trDecrease3Cfg, trIncreaseCfg, trIncrease3Cfg, trebleCfg, tripleTrebleCfg,
];

function loadGroup(config: StitchGroupConfig): LoadedStitchGroup | null {
  try {
    if (!config.id || !Array.isArray(config.variants) || !config.variants.length) {
      return null;
    }
    const icons = iconMap[config.id] || {};
    return {
      config,
      iconUrls: Object.fromEntries(
        config.variants.map(v => [v.id, icons[v.id] || ''])
      ),
      defaultVariantId: config.variants[0].id,
    };
  } catch (e) {
    console.warn('Failed to load stitch group: ' + config?.id, e);
    return null;
  }
}

export const STITCH_GROUPS: LoadedStitchGroup[] = allConfigs
  .map(c => loadGroup(c))
  .filter((g): g is LoadedStitchGroup => g !== null)
  .sort((a, b) => a.config.order - b.config.order);

export const VARIANT_TO_GROUP: Record<string, LoadedStitchGroup> = {};
export const VARIANT_CONFIGS: Record<string, StitchVariantConfig> = {};

for (const group of STITCH_GROUPS) {
  for (const variant of group.config.variants) {
    VARIANT_TO_GROUP[variant.id] = group;
    VARIANT_CONFIGS[variant.id] = variant;
  }
}

export const STITCH_KEYS = STITCH_GROUPS.flatMap(
  g => g.config.variants.map(v => v.id)
);

for (const group of STITCH_GROUPS) {
  for (const variant of group.config.variants) {
    const url = group.iconUrls[variant.id];
    if (url) registerSvgSource(variant.id, url);
  }
}

export type { StitchVariantConfig, StitchGroupConfig, LoadedStitchGroup } from './types';
